import useInitializeProductAdvancedForm from './useInitializeProductAdvancedForm'

export default useInitializeProductAdvancedForm
